import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import ClickToCall, { CDP_CLICK_TO_CALL_MODAL } from './Book/components/ClickToCall';
import ReportInfoModal, { REPORT_INACCURATE_MODAL } from './Modals/ReportInaccurateInfoModal';
import ReportReviewModal, { REPORT_REVIEW_MODAL } from './Modals/ReportReviewModal';
import { BOOKING_TIME_SELECTOR_MODAL } from './Book/components/BookModule/Modal';
import BookModal from './Book/components/BookModule/Modal';
import LeaveAReviewModal, { LEAVE_A_REVIEW_MODAL } from './Modals/LeaveAReviewModal';

export default class ModalController extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    newBooking: PropTypes.object,
    fetchPartnerClinics: PropTypes.func.isRequired,
    fetchLocationSlotsData: PropTypes.func.isRequired,
    nearbyPartnerClinics: PropTypes.array.isRequired,
    modalState: PropTypes.object,
    hideModal: PropTypes.func,
    handleRequestAppointmentClick: PropTypes.func,
    login: PropTypes.object,
    accountSummary: PropTypes.object,
    suggestions: PropTypes.array,
    reasonForVisit: PropTypes.string,
    setBookingProfile: PropTypes.func,
  };

  render = () => {
    const {
      location,
      newBooking,
      nearbyPartnerClinics,
      fetchPartnerClinics,
      hideModal,
      modalState,
      fetchLocationSlotsData,
      handleRequestAppointmentClick,
      setBookingProfile,
      login,
      accountSummary,
      suggestions,
      reasonForVisit,
    } = this.props;
    return (
      <Fragment>
        <ReportInfoModal
          open={modalState[REPORT_INACCURATE_MODAL] || false}
          onClose={() => hideModal(REPORT_INACCURATE_MODAL)}
        />
        <ClickToCall
          open={modalState[CDP_CLICK_TO_CALL_MODAL] || false}
          location={location}
          nearbyPartnerClinics={nearbyPartnerClinics}
          fetchPartnerClinics={fetchPartnerClinics}
          onClose={() => hideModal(CDP_CLICK_TO_CALL_MODAL)}
        />
        <LeaveAReviewModal
          open={modalState[LEAVE_A_REVIEW_MODAL] || false}
          location={location}
          onClose={() => hideModal(LEAVE_A_REVIEW_MODAL)}
        />
        <ReportReviewModal
          open={modalState[REPORT_REVIEW_MODAL] || false}
          onClose={() => hideModal(REPORT_REVIEW_MODAL)}
        />
        {modalState[BOOKING_TIME_SELECTOR_MODAL] && (
          <BookModal
            newBooking={newBooking}
            open={modalState[BOOKING_TIME_SELECTOR_MODAL] || false}
            location={location}
            fetchLocationSlotsData={fetchLocationSlotsData}
            onClose={() => hideModal(BOOKING_TIME_SELECTOR_MODAL)}
            fullScreen
            handleRequestAppointmentClick={handleRequestAppointmentClick}
            login={login}
            accountSummary={accountSummary}
            suggestions={suggestions}
            reasonForVisit={reasonForVisit}
            setBookingProfile={setBookingProfile}
          />
        )}
      </Fragment>
    );
  };
}
